/* eslint-disable camelcase */
import { search as recommendationAiSearch } from './gtagForRecommendationAi';

const analytics = {
  logEvent: (event, data) => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...data,
    });
  },
};

export const set_user_id = (userId) => {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      user_id: userId
    });
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const page_view = () => {
  if (typeof window === 'undefined') return;

  analytics.logEvent('page_view', {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    page_title: document.title,
  });
};

let pendingPageViewCleanup = null;

const cancelPendingPageView = () => {
  if (pendingPageViewCleanup) {
    pendingPageViewCleanup();
    pendingPageViewCleanup = null;
  }
};

/** Emit page_view after Next.js updates document.title on client navigations. */
export const schedulePageViewAfterTitleUpdate = () => {
  if (typeof window === 'undefined') return;

  cancelPendingPageView();

  const titleEl = document.querySelector('title');
  if (!titleEl) {
    page_view();
    return;
  }

  const previousTitle = document.title;
  let sent = false;
  let observer = null;
  let timeoutId = null;
  let rafId = null;

  const cleanup = () => {
    observer?.disconnect();
    if (timeoutId !== null) window.clearTimeout(timeoutId);
    if (rafId !== null) window.cancelAnimationFrame(rafId);
    if (pendingPageViewCleanup === cleanup) {
      pendingPageViewCleanup = null;
    }
  };

  const send = () => {
    if (sent) return;
    sent = true;
    cleanup();
    page_view();
  };

  pendingPageViewCleanup = cleanup;

  if (typeof MutationObserver !== 'undefined') {
    observer = new MutationObserver(send);
    observer.observe(titleEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  rafId = window.requestAnimationFrame(() => {
    if (!sent && document.title !== previousTitle) {
      send();
    }
  });

  timeoutId = window.setTimeout(send, 500);
};

export const cancelScheduledPageView = () => {
  cancelPendingPageView();
};

export const search = (search_term, other_params) => {
  if (search_term) {
    recommendationAiSearch(search_term);

    analytics.logEvent('search', {
      search_term,
      ...(other_params || {})
    });
  }
};

export const login = (method) => {
  if (method) {
    analytics.logEvent('login', {
      method,
    });
  }
};

export const sign_up = (method) => {
  if (method) {
    analytics.logEvent('sign_up', {
      method,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#view_promotion
export const view_promotion = (promotions) => {
  if (promotions) {
    analytics.logEvent('view_promotion', {
      promotions,
    });
  }
};

/* below not yet implemented */

export const exception = (description) => {
  if (description) {
    analytics.logEvent('exception', {
      description,
      fatal: false,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#timing_complete
export const timing_complete = (name, value) => {
  if (name && value) {
    analytics.logEvent('timing_complete', {
      name,
      value,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#view_search_results
export const view_search_results = (search_term, items) => {
  if (search_term && items) {
    analytics.logEvent('view_search_results', {
      search_term,
      items,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#share
export const share = (method, content_type, content_id) => {
  if (method && content_type && content_id) {
    analytics.logEvent('share', {
      method,
      content_type,
      content_id,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#select_content
export const select_content = (content_type, items, promotions) => {
  if (content_type) {
    analytics.logEvent('select_content', {
      content_type,
      items,
      promotions,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#view_item
export const view_item = (items) => {
  if (items) {
    analytics.logEvent('view_item', {
      items,
    });
  }
};

// https://developers.google.com/gtagjs/reference/event#view_item_list
export const view_item_list = (items) => {
  if (items) {
    analytics.logEvent('view_item_list', {
      items,
    });
  }
};
